import { useLocationsContext } from '@/src/contexts/LocationsContext'
import { PROCUREMENT_AND_MARKETS_BASE_ROUTE, TABS } from '@/src/utils/constants'
import { Spinner } from '@chakra-ui/react'
import { useCompanyConfigForProcurement } from '@features/procurement-and-markets/overview/energy/hooks/useCompanyConfigForProcurement.hook'
import React, { Suspense } from 'react'
import { Navigate } from 'react-router-dom'
import { LayoutMain } from '../../layouts/LayoutMain/LayoutMain'
import { AuthRoute } from '../../routes/routes.components'

const ProcurementLazy = React.lazy(() => import('./Procurement.screen'))
const EnergyProcurementV2OverviewLazy = React.lazy(() => import('./overview/energy/EnergyProcurementOverview'))
const ProcurementEnergyMarketsLazy = React.lazy(() => import('./energy-markets/ProcurementEnergyMarkets.page'))

const ProcurementPage = (
  <Suspense fallback={<div />}>
    <ProcurementLazy />
  </Suspense>
)
// Convert OverviewPageWrapper to a normal component
const OverviewPageWrapper = () => {
  const { companyPgId } = useLocationsContext()
  const response = useCompanyConfigForProcurement(companyPgId)

  if (response?.isPending) return <Spinner mt={'16px'} />

  if (response?.data?.configValue.retoolDashboardUrl) {
    return (
      <iframe
        title={'Custom Procurement View'}
        src={response.data.configValue.retoolDashboardUrl}
        width='100%'
        style={{
          minHeight: '75vh',
          height: '80vh',
          maxHeight: '100%',
        }}
      />
    )
  }

  return (
    <Suspense fallback={<div />}>
      <EnergyProcurementV2OverviewLazy />
    </Suspense>
  )
}

// Create a lazy component that will render OverviewPageWrapper
const OverviewPageWrapperLazy = React.lazy(() =>
  Promise.resolve({
    default: OverviewPageWrapper,
  })
)

const OverviewPage = (
  <Suspense fallback={<div />}>
    <OverviewPageWrapperLazy />
  </Suspense>
)

const EnergyMarketsPage = (
  <Suspense fallback={<div />}>
    <ProcurementEnergyMarketsLazy />
  </Suspense>
)

export const procurementAndMarketsRoutes = [
  {
    path: PROCUREMENT_AND_MARKETS_BASE_ROUTE,
    element: (
      <AuthRoute>
        <LayoutMain />
      </AuthRoute>
    ),
    children: [
      { path: '', element: <Navigate to={TABS.procurementAndMarkets.procurement} replace /> },
      {
        path: '',
        element: ProcurementPage,
        children: [
          { path: TABS.procurementAndMarkets.procurement, element: OverviewPage },
          { path: TABS.procurementAndMarkets.markets, element: EnergyMarketsPage },
        ],
      },
    ],
  },
]
